import type { VariavelObrigatoria } from '../config';
import { frase } from '../util/formato';

/**
 * A tela que aparece no lugar da aplicação quando falta variável obrigatória.
 *
 * É tela, e não `throw` no console, porque quem remixa no Lovable ou no AI
 * Studio não abre o console: ele vê a página em branco, conclui que o remix
 * quebrou, e desiste. Aqui ele lê o nome exato do que falta e onde preencher.
 *
 * O tom é o do produto: relata o que aconteceu e diz o que fazer. Não pede
 * desculpa e não decora.
 */
export function ConfiguracaoAusente({ faltando }: { faltando: readonly VariavelObrigatoria[] }) {
  const uma = faltando.length === 1;

  return (
    <main className="convite">
      <div className="convite-coluna">
        <div className="aviso aviso--erro">
          <span className="aviso__rotulo">Não subiu</span>
          <div className="aviso__corpo">
            <h1>{uma ? 'Falta uma variável de ambiente' : 'Faltam variáveis de ambiente'}</h1>
            <p>
              {uma ? 'A variável ' : 'As variáveis '}
              <strong>{frase(faltando as string[])}</strong>
              {uma ? ' não foi preenchida' : ' não foram preenchidas'}, e sem {uma ? 'ela' : 'elas'}{' '}
              a aplicação não fala com o banco. Ela recusa subir em vez de abrir e quebrar no
              primeiro clique — que é a pior forma de descobrir isso.
            </p>
          </div>
        </div>

        <section>
          <h2>Onde preencher</h2>
          <ul>
            <li>
              <strong>Local</strong>: copie <code>.env.example</code> para <code>.env</code> e
              preencha os valores do seu projeto Supabase.
            </li>
            <li>
              <strong>Lovable</strong> e <strong>AI Studio</strong>: nas configurações do projeto. O
              remix nunca copia secrets, por segurança da plataforma — quem remixa preenche do zero.
            </li>
            <li>
              <strong>Coolify</strong>: nas variáveis do serviço.
            </li>
          </ul>
          <p>
            Os valores estão em <em>Project Settings → API</em> do Supabase:{' '}
            <code>VITE_SUPABASE_URL</code> é a URL do projeto e <code>VITE_SUPABASE_ANON_KEY</code>{' '}
            é a chave <em>anon / public</em>. A chave <em>service role</em> não vai para o
            navegador: ela ignora a política de acesso do banco.
          </p>
          <p>
            Depois de preencher, a aplicação precisa ser <strong>construída de novo</strong> —
            variável <code>VITE_*</code> entra no pacote na hora do build, não em tempo de execução.
          </p>
        </section>
      </div>
    </main>
  );
}
